import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Btn, inputCls } from "@/components/common";
import { Plus, Trash2 } from "lucide-react";

const CATS = [["caffe", "Caffè"], ["birra", "Birra"], ["gadget", "Gadget"], ["altro", "Altro"]];

function StockCell({ it, onLoaded }) {
  const [q, setQ] = useState("");
  const low = it.last_load && it.stock != null && it.stock <= 0.2 * it.last_load;
  const load = async () => {
    try { const { data } = await api.post(`/bar/stock/${it.id}/load`, { qty: Number(q) }); onLoaded(data); setQ(""); toast.success(`${it.name}: giacenza ${data.stock}`); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="flex items-center gap-1 shrink-0">
      <span className={`text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap min-w-[120px] text-center ${low ? "bg-rose-100 text-rose-700" : "bg-slate-100 text-slate-600"}`} data-testid={`bar-stock-${it.id}`}>
        {it.stock == null ? "giacenza —" : `giacenza ${it.stock}`}{it.last_load ? ` / ${it.last_load}` : ""}
      </span>
      <input type="number" min="1" value={q} onChange={(e) => setQ(e.target.value)} placeholder="+ pezzi" disabled={!it.id} className={`${inputCls} w-24`} data-testid={`bar-load-qty-${it.id}`} />
      <button onClick={load} disabled={!it.id || !(Number(q) > 0)} className="text-xs font-semibold px-2 py-2 rounded-md border border-sky-200 text-sky-700 disabled:opacity-40" data-testid={`bar-load-${it.id}`}>Carica</button>
    </div>
  );
}

export default function BarSettings({ onSaved }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/bar/settings").then((r) => setItems(r.data.items)); }, []);
  const set = (i, k, v) => setItems((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  if (!items) return <div className="text-slate-400" data-testid="bar-settings-loading">Caricamento…</div>;
  const save = async () => {
    try {
      await api.put("/bar/settings", { items: items.map((x) => ({ ...x, price: Number(x.price) || 0 })) });
      toast.success("Listino salvato");
      onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 max-w-4xl space-y-4 overflow-x-auto" data-testid="bar-settings">
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={it.id || i} className="flex gap-2 items-center" data-testid={`bar-item-row-${i}`}>
            <input value={it.name} onChange={(e) => set(i, "name", e.target.value)} className={inputCls} placeholder="Nome" data-testid={`bar-item-name-${i}`} />
            <select value={it.category} onChange={(e) => set(i, "category", e.target.value)} className={`${inputCls} w-32`} data-testid={`bar-item-cat-${i}`}>
              {CATS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
            <input type="number" step="0.5" min="0" value={it.price} onChange={(e) => set(i, "price", e.target.value)} className={`${inputCls} w-28`} data-testid={`bar-item-price-${i}`} />
            <span className="text-sm text-slate-500">€</span>
            <StockCell it={it} onLoaded={(st) => setItems((l) => l.map((x, j) => (j === i ? { ...x, ...st } : x)))} />
            <button onClick={() => setItems((l) => l.filter((_, j) => j !== i))} className="text-rose-500" data-testid={`bar-item-del-${i}`}><Trash2 size={15} /></button>
          </div>
        ))}
        <button onClick={() => setItems((l) => [...l, { id: "", name: "", category: "gadget", price: 0 }])} className="text-sm text-sky-700 font-semibold inline-flex items-center gap-1" data-testid="bar-item-add"><Plus size={14} /> Aggiungi articolo</button>
      </div>
      <p className="text-xs text-slate-500 border-t border-slate-100 pt-3">Giacenza: scrivi quanti pezzi hai caricato e premi "Carica". Ogni consumo segnato su una camera la scala da solo; sotto il 20% dell'ultimo carico arriva l'avviso in Dashboard. Il barman entra con il suo account: lo crea in Utenti con il ruolo "Barman".</p>
      <Btn onClick={save} data-testid="bar-settings-save">Salva</Btn>
    </div>
  );
}
